import { styled } from '@mui/material/styles';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary, { accordionSummaryClasses } from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import type { AccordionProps } from '@mui/material/Accordion';
import type { AccordionSummaryProps } from '@mui/material/AccordionSummary';
import type { FC } from 'react';

const StyledAccordionWrapper = styled(MuiAccordion)(({ theme }) => ({
  border: 'none',
  backgroundColor: theme.customPalette.panels.collapsibleBoxes.header.background,
  color: 'inherit',
  borderRadius: '0.2em',
  marginTop: '.5em',
  overflow: 'hidden',

  '& > div': {
    backgroundColor: theme.customPalette.panels.collapsibleBoxes.body.background
  },

  '&:not(:last-child)': {
    borderBottom: 0
  },
  '&::before': {
    display: 'none'
  },
  '& .MuiAccordionSummary-expandIconWrapper': {
    color: theme.customPalette.panels.side.font
  }
}));

export const StyledAccordion: FC<AccordionProps> = (props) => {
  return <StyledAccordionWrapper disableGutters elevation={0} square {...props} />;
};

export const StyledAccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary expandIcon={<ExpandMoreIcon />} {...props} />
))(({}) => ({
  backgroundColor: 'rgba(0, 0, 0, .03)',
  flexDirection: 'row-reverse',
  [`& .${accordionSummaryClasses.content}`]: {
    marginLeft: '0.2em',
    paddingLeft: '0.3em',
    marginTop: '0.75em',
    marginBottom: '0.75em'
  },
  '&': {
    paddingLeft: '0.5em',
    minHeight: 'unset'
  },
  '& p.MuiTypography-root': {
    fontSize: '1.2rem'
  },

  '@media (max-width: 100rem)': {
    '& p.MuiTypography-root': {
      fontSize: '1.1rem'
    },
    [`& .${accordionSummaryClasses.content}`]: {
      marginLeft: '0.2em',
      paddingLeft: '0.3em',
      marginTop: '0.5em',
      marginBottom: '0.5em'
    }
  }
}));

export const StyledAccordionDetails = styled(MuiAccordionDetails)(({}) => ({
  padding: '0.2em 0em 0 0.5em',
  border: 'none',
  '@media (max-width: 100rem)': {
    padding: '0 0 0 0.25em'
  }
}));
